import { render, staticRenderFns } from "./PageBottomProductInquiryContent.vue?vue&type=template&id=70969e8e&scoped=true&"
import script from "./PageBottomProductInquiryContent.vue?vue&type=script&lang=ts&"
export * from "./PageBottomProductInquiryContent.vue?vue&type=script&lang=ts&"
import style0 from "./PageBottomProductInquiryContent.vue?vue&type=style&index=0&id=70969e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70969e8e",
  null
  
)

export default component.exports